import { Col, Modal, Row, Skeleton, Typography, message } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import {
  CommentJson,
  FilterComment,
} from "features/comment/types/comment.type";
import useGetCommentListEndpoint from "Hooks/useGetCommentListEndpoint";
import CommentModel from "common/models/CommentModel";
import { useAppDispatch, useAppSelector } from "app/hooks";
import CommentForm from "../commentForm.tsx/CommentForm";
import { setModel } from "features/comment/CommentSlice";
import { useDeleteCommentMutation } from "features/comment/service/comment.service";

type Props = {
  data: CommentJson;
};
const QaItem = ({ data }: Props) => {
  const [messageApi, contextHolder] = message.useMessage();
  ////////////////////
  const [idEdit, setIdEdit] = useState(0);
  const [confirmDelete, setConfirmDelete] = useState(0);
  ////////////////////
  const currentUser = useAppSelector((state) => state.auth.user);
  const dispatch = useAppDispatch();
  const defaultFilters: FilterComment = useMemo(
    () => CommentModel.getDefaultFilter(),
    []
  );

  const [filters, setFilters] = useState<FilterComment>({
    ...defaultFilters,
    limit: 1,
    item_id: data.item_id,
    item_type: data.item_type,
    parent_id: data.id,
  });

  const {
    listData: { currentData, data: dataQa, isLoading },
  } = useGetCommentListEndpoint({ filters: filters, typeList: "comment" });

  const [
    deleteComment,
    { isLoading: deleteLoading, isError, isSuccess: deleteSuccess },
  ] = useDeleteCommentMutation();

  /////////////////////////
  // function
  const handleSuccessFormEdit = () => {
    setIdEdit(0);
    dispatch(setModel(null));
    messageApi.open({
      content: `Sửa câu hỏi thành công`,
      duration: 3,
      type: "success",
    });
  };

  const handleDeleteQa = async (id: number) => {
    try {
      const res = await deleteComment({ id }).unwrap();
      if (res) {
        setConfirmDelete(0);
        messageApi.open({
          content: `Xóa câu hỏi thành công !`,
          duration: 3,
          type: "success",
        });
      }
    } catch (error) {
      messageApi.open({
        content: `Có lỗi không thể xóa !`,
        duration: 3,
        type: "error",
      });
    }
  };
  const handleFecthQa = async () => {};

  //
  // useEffect(() => {
  //   if (data) {
  //   }
  // }, []);
  const styles = {
    button: {
      border: "none",
      boxShadow: "none",
      outline: "none",
      display: "flex",
      justifyContent: "start",
      alignItems: "center",
      gap: "4px",
      cursor: "pointer",
      margin: 0,
      height: "12px",
      backgroundColor: "transparent",
      fontSize: "12px",
      // borderRight: "1px solid #E6E7E8",
      padding: 0,
    },
  };
  return (
    <>
      {contextHolder}
      <Row style={{ width: "100%" }}>
        <Col
          md={1}
          sm={1}
          span={3}
          style={{ opacity: data.status !== 1 ? "35%" : "1" }}
        >
          <Typography.Text style={{ fontWeight: 700 }}>Hỏi:</Typography.Text>
        </Col>
        <Col sm={23} md={23} span={21}>
          <Typography.Text
            style={{
              textAlign: "justify",
              fontWeight: 700,
              opacity: data.status !== 1 ? "35%" : "1",
            }}
          >
            {data.detail}
          </Typography.Text>
          {data.status !== 1 && (
            <Row gutter={[24, 24]} style={{ width: "100%", marginTop: "17px" }}>
              {currentUser &&
                currentUser.company.customer.id === data.customer_id && (
                  <>
                    <Col>
                      <button
                        style={{
                          ...styles.button,
                        }}
                        onClick={() => {
                          setIdEdit(data.id);
                          dispatch(setModel(data));
                        }}
                      >
                        <div
                          className="comment_icon"
                          id="comment_icon-edit"
                          style={{ width: 24, height: 24 }}
                        ></div>
                        <p style={{ margin: 0 }}>Sửa</p>
                      </button>
                    </Col>
                    <Col style={{ display: "flex", justifyContent: "center" }}>
                      <span
                        style={{
                          border: "1px solid #E6E7E8",
                          transform: "rotate(180deg)",
                        }}
                      ></span>
                    </Col>
                    <Col>
                      <button
                        style={{
                          ...styles.button,
                        }}
                        onClick={() => setConfirmDelete(data.id)}
                      >
                        <div
                          className="comment_icon"
                          id="comment_icon-delete"
                          style={{ width: 24, height: 24 }}
                        ></div>
                        Xóa
                      </button>
                    </Col>
                  </>
                )}
              {data.status !== 1 && (
                <>
                  {currentUser && (
                    <Col style={{ display: "flex", justifyContent: "center" }}>
                      <span
                        style={{
                          border: "1px solid #E6E7E8",
                          transform: "rotate(180deg)",
                        }}
                      ></span>
                    </Col>
                  )}
                  <Col>
                    <p
                      style={{
                        ...styles.button,
                        color: "#D72229",
                      }}
                    >
                      Câu hỏi của bạn đang chờ duyệt
                    </p>
                  </Col>
                </>
              )}
            </Row>
          )}
        </Col>
      </Row>
      {isLoading ? (
        <Skeleton paragraph={{ rows: 1 }} active></Skeleton>
      ) : (
        <>
          {dataQa && dataQa.items.length > 0 && (
            <Row style={{ width: "100%" }}>
              <>
                <Col sm={1} md={1} span={3}>
                  <Typography.Text>Đáp:</Typography.Text>
                </Col>
                <Col sm={23} md={23} span={21}>
                  <Typography.Text style={{ textAlign: "justify" }}>
                    {dataQa.items[0].detail}
                  </Typography.Text>
                </Col>
              </>
            </Row>
          )}
        </>
      )}
      <Modal
        key={"edit"}
        open={idEdit > 0}
        title={`Sửa câu hỏi`}
        centered
        onCancel={() => {
          setIdEdit(0);
          dispatch(setModel(null));
        }}
        okButtonProps={{ style: { display: "none" } }}
        cancelButtonProps={{ style: { display: "none" } }}
        bodyStyle={{ padding: "0" }}
        destroyOnClose={true}
      >
        <CommentForm
          item_id={data.item_id}
          parent_id={data.parent_id}
          item_type={data.item_type}
          handleSuccess={handleSuccessFormEdit}
          handleCancelModal={() => {
            setIdEdit(0);
            dispatch(setModel(null));
          }}
          form_type={"qa"}
          idEditing={idEdit}
        ></CommentForm>
      </Modal>
      <Modal
        title={
          <Typography.Title
            level={4}
            style={{
              fontSize: "24px",
              lineHeight: "29px",
              color: "#3A393A",
              margin: "0 0 8px 0",
              textAlign: "center",
            }}
          >
            Xóa câu hỏi
          </Typography.Title>
        }
        open={confirmDelete > 0}
        onCancel={() => {
          setConfirmDelete(0);
        }}
        onOk={() => handleDeleteQa(confirmDelete)}
        cancelButtonProps={{ style: { flex: 1 } }}
        okButtonProps={{ style: { backgroundColor: "#D72229", flex: 1 } }}
        wrapClassName="modal_delete-qa"
        destroyOnClose={true}
      ></Modal>
    </>
  );
};

export default QaItem;
